export default __webpack_public_path__ + "static/ErikA-1c5bb96684bb58af17ec6d8204b38f70.png";